// extracted by mini-css-extract-plugin
module.exports = {"row":"r_Ak7V","gutter":"_3or671","block":"_2yzY93","column":"_1UhrFj","1:3":"_1qc06x","1:4":"_17Dbym","1:2":"_2znMHn","2:3":"Go2xIN","3:4":"_2PoyAX"};